import { createClient } from '@supabase/supabase-js';

const analyticsUrl = import.meta.env.VITE_ANALYTICS_SUPABASE_URL;
const analyticsKey = import.meta.env.VITE_ANALYTICS_SUPABASE_ANON;

export const supabaseAnalytics = createClient(analyticsUrl, analyticsKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
});
